<template>
  <div>
    <b-navbar type="dark" variant="info" style="justify-content: space-between;">
      <b-navbar-brand>
        <img :src="require('@/assets/logo.png')" class="d-inline-block align-top" alt="logo" width="6%"
          height="6%" />
          线路人形监控系统
      </b-navbar-brand>


      <div class="right">
        <div v-if="role == '0'" style="padding: 0 50px 0 0;cursor: pointer; font-size: 18px;color: #fff;"
          @click="navigateToSettings">系统设置</div>
        <div v-if="role == '0'" style="padding: 0 50px 0 0;cursor: pointer; font-size: 18px;color: #fff;"
          @click="navigateToControl">
          监控点管理</div>
        <div style="cursor: pointer" @click="navigateToUser" v-if="role == '0'">
          <img :src="require('@/assets/user.png')" class="d-inline-block align-top" alt="logo" width="50px"
            height="50px" />
        </div>
        <div style="padding: 0 50px 0 50px;cursor: pointer; font-size: 18px;color: #fff;" @click="navigateToLogout">
          退出
        </div>

      </div>
    </b-navbar>

    <b-container fluid class="mt-2">
      <b-card no-body>
        <b-breadcrumb>
          <b-breadcrumb-item @click="navigateToHome">
            <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
            首页
          </b-breadcrumb-item>
          <b-breadcrumb-item active>用户管理</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="btn1">
          <button type="button" class="btn btn-info" style="margin-right: 40px;"
            @click="handleOpenAddUser">添加用户</button>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">序号</th>
              <th scope="col">用户名</th>
              <th scope="col">密码</th>
              <!-- <th scope="col">角色</th> -->
              <th scope="col">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>{{ index + 1 }}</td>
              <td v-text="item.username"></td>
              <td @click="isiType(index)">
                <input :type='item.iType' v-model="item.password" disabled="true" style="border: none;" />
              </td>
              <!-- <td v-if="item.role == 0">管理员</td>
              <td v-else-if="item.role == 1">普通用户</td> -->
              <td>
                <button style="margin-right: 10px;" type="button" class="btn btn-info btn-sm "
                  @click="handleOpenPassword(item, index)">编辑</button>
                <!-------------------------------------------------------------------------------------------------------------- -->
                <!-- <button style="margin-right: 10px;" type="button" class="btn btn-info btn-sm "
                  @click="handleOpenStation(item, index)">权限设置</button> -->
                <!----------------------------------------------------------------------------------------------------------------- -->
                <button type="button" class="btn btn-danger btn-sm " @click="del(index)">删除</button>
              </td>
            </tr>

          </tbody>
        </table>


      </b-card>

    </b-container>


    <b-modal no-close-on-backdrop no-close-on-esc v-model="show1" title="账户信息">
      <div class="modal-box">
        <b-form>
          <b-form-group id="input-group-1" label="用户名" label-for="input-1">
            {{ form1.username }}
          </b-form-group>
          <b-form-group id="input-group-2" label="密码" label-for="input-2">
            {{ form1.password }}
          </b-form-group>
          <b-form-group id="input-group-2" label="新密码(长度8~20,必须强密码)" label-for="input-2">
            <b-form-input id="input-2" v-model="form1.newpassword"></b-form-input>
          </b-form-group>
          <!-- <label class="radio-inline">
            <input type="radio" name="role" id="user_1" value="1" v-model="form1.role"> 普通用户
          </label>
          <label class="radio-inline">
            <input type="radio" name="role" id="admin_0" value="0" v-model="form1.role"> 管理员
          </label> -->
        </b-form>
      </div>
      <template v-slot:modal-footer>
        <b-button type="reset" variant="danger" @click="show1 = false">取消</b-button>
        <b-button type="submit" variant="primary" @click="handleSaveUser">确认修改</b-button>
      </template>
    </b-modal>

    <b-modal no-close-on-backdrop no-close-on-esc v-model="show2" title="添加用户">
      <div class="modal-box">
        <b-form>
          <b-form-group id="input-group-1" label="用户名" label-for="input-1">
            <b-form-input id="input-1" v-model="form2.username"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label="密码 (长度8~20,必须强密码)" label-for="input-2">
            <b-form-input id="input-2" v-model="form2.password"></b-form-input>
          </b-form-group>
          <!-- <label class="radio-inline">
            <input type="radio" name="role" id="user_1" value="1" v-model="form2.role"> 普通用户
          </label>
          <label class="radio-inline">
            <input type="radio" name="role" id="admin_0" value="0" v-model="form2.role"> 管理员
          </label> -->
        </b-form>
      </div>
      <template v-slot:modal-footer>
        <b-button type="reset" variant="danger" @click="show2 = false">取消</b-button>
        <b-button type="submit" variant="primary" @click="handleSaveAddUser">确定</b-button>
      </template>
    </b-modal>

    <b-modal no-close-on-backdrop no-close-on-esc v-model="show3" size="xl" title="站点权限设置">
      <div class="modal-box">
        <div>用户名：{{ form3.username }}</div>
        <div>用户ID：{{ form3.userUuid }}</div>
        <b-form>
          <table class="table table-striped" id="vcfResult">
            <thead>
              <tr>
                <th scope="col" id="xh">序号</th>
                <th scope="col" id="lx">路线名</th>
                <th scope="col" id="workSection">工务段</th>
                <th scope="col" id="phone">监控点名称</th>
                <th scope="col" id="k">里程</th>
                <th scope="col" id="qx">权限</th>
              </tr>
            </thead>
            <tbody>

              <tr v-for="(items, index) in satitem" :key="index">
                <td>{{ items.position }}</td>
                <th scope="row">{{ items.lineName }}</th>
                <td>{{ items.workSection }}</td>
                <td>{{ items.stationName }}</td>
                <td>{{ items.distance }}</td>
                <td>
                  <b-form-checkbox v-model="items.bol" name="checkbox-1" :value="true" :unchecked-value="false">
                  </b-form-checkbox>
                </td>
              </tr>
            </tbody>
          </table>
        </b-form>
      </div>
      <template v-slot:modal-footer>
        <b-button type="reset" variant="danger" @click="show3 = false">取消</b-button>
        <b-button type="submit" variant="primary" @click="handleSaveStation">确认修改</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import zxcvbn from 'zxcvbn'
// import e from 'express';
export default {
  name: 'UserManage',
  created() {
    this.role = window.localStorage.getItem('role');
    this.username = window.localStorage.getItem('username');
    this.password = window.localStorage.getItem('password');
    this.userUuid = window.localStorage.getItem('userUuid')//获取用户id

    //生命周期
    this.getUserlist()
  },
  data() {
    return {
      username: '',
      password: "",
      userUuid: '',
      items: [],
      satitem: [],
      show1: false,
      show2: false,
      show3: false,
      form1: {
        username: 'admin',
        password: '123456'
      },
      form2: {
        username: '',
        password: '',
        role: 1
      },
      form3: {
        username: '',

      },
      role: '',
      radioValue: '',
      arrindex: 0,
    };


  },
  methods: {
    // 修改点击的input的type来控制密码的显示和隐藏
    isiType(i) {
      // 修改的是数组items中的iType所以说items
      if (this.items[i].iType == 'text') {
        this.$set(this.items[i], 'iType', 'password')

      } else {
        this.$set(this.items[i], 'iType', 'text')
        // this.items[i].iType = 'text'
      }
    },
    // 获取用户列表
    getUserlist() {
      axios.get(`${this.$apiRoot}/user/getUsers`)
        .then((response) => {
          this.items = response.data.data
          this.items.map(item => {
            this.$set(item, 'iType', 'password')
          })
        })
    },

    //=========================================================================================================================================== 
    navigateToUser() {
      this.$router.push({
        path: '/usermanage'
      })
    },
    navigateToControl() {
      this.$router.push({
        path: '/control'
      })
    },
    navigateToHome() {
      this.$router.push({
        path: '/home'
      })
    },
    navigateToSettings() {
      this.$router.push({
        path: '/settings'
      })
    },
    // 添加用户
    handleOpenAddUser(e) {
      this.form2['username'] = '';
      this.form2['password'] = '';
      this.form2['role'] = 1;
      this.show2 = true;
    },

    //验证密码强度
    checkPasswordStrength(pwd) {
      if (pwd === '') {
        alert('请输入密码');
        return false;
      }
      if(pwd.length<8 || pwd.length>20)
      {
        alert('密码长度在8-20之间');
        return false;
      }
  
      const result = zxcvbn(pwd);
      if (result.score < 3) {
        alert('密码强度不够，密码应该包含大小写字母、数字和特殊字符');
        return false;
      }
      return true;
    },
    
    handleSaveAddUser() {
      //判断表单格式
      if (this.form2.username === '' ) {
        alert("用户名不为空！");
        return
      }
      if(this.form2.username.length<4 || this.form2.username.length>20){
        alert('用户名长度在4-20之间');
        return
      }

      if (!this.checkPasswordStrength(this.form2.password)) {
        return;
      }
      axios.post(`${this.$apiRoot}/user/addUser`, this.form2)
        .then(res => {
          this.getUserlist()
          //关闭弹窗
          this.show2 = false
          var code = res.data.code;
          if (code == 400) {
            alert("密码长度在6-20之间\n用户名长度在4-20之间");
          } else if (code == 200) {
            this.getUserlist()
            this.show2 = false
          } else {
            alert("添加失败！")
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    //编辑账号信息
    handleOpenPassword(item, index) {
      this.form1['password'] = item.password;
      this.form1['username'] = item.username;
      this.form1['newpassword'] = '';
      this.form1['role'] = item.role;
      this.show1 = true;
      this.arrindex = index
    },

    //编辑密码
    handleSaveUser() {
      //判断表单格式
      if(this.form1.newpassword ==""){
        alert("请填写新密码!!");
        return
      }
      if (this.form1.newpassword.length < 8 || this.form1.newpassword.length >20) {
        alert("密码长度应在8-20之间!!");
        return
      }
     
      if(!this.checkPasswordStrength(this.form1.newpassword)){
        return;
      }
      // 发送请求
      let info = {
        username: this.form1.username,
        password: this.form1.newpassword,
        role: this.form1.role
      }
      axios.post(`${this.$apiRoot}/user/modifyUser`, info)
        .then(res => {
          var code = res.data.code;
          if (code == 400) {
            alert("请确认新密码长度在8-20之间!");
          } else if (code == 200) {
            this.getUserlist()
            this.show1 = false
          }
        })
        .catch(err => {
          console.log(err)

        })

    },
    del(i) {
      this.boxOne1 = ''
      this.$bvModal.msgBoxConfirm('请确认是否要删除该用户？', {
        title: '请确认',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: '确认',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxOne1 = value
          if (this.boxOne1) {
            axios.post(`${this.$apiRoot}/user/deleteUser`, this.items[i])
              .then(res => {
                var code = res.data.code;
                if (code == 200) {
                  this.getUserlist()
                } else {
                  alert("删除失败！");
                }
              })
              .catch(err => {
                console.log(err)
              })
          }

        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })

    },

    //退出登录    
    //退出登录
    navigateToLogout() {

      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('是否退出登录?', {
        title: '请确认',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: '退出',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            window.localStorage.removeItem('username')
            window.localStorage.removeItem('password')
            window.localStorage.removeItem('role')
            window.localStorage.removeItem('token')
            this.$router.push({
              path: '/'
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err);
        })

    },
  }
}

</script>
<style>
.btn1 {
  /* padding: 0 0 20px 80%
   */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  padding-bottom: 20px;
}
</style>
